import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    search: {
        id: 'header.header_input_placeholder',
        defaultMessage: 'Search',
    },
    searchCancel: {
        id: 'header.search_cancel',
        defaultMessage: 'Cancel',
    },
    noResults: {
        id: 'header.search_no_results',
        defaultMessage: 'No results found',
    },
    trending: {
        id: 'header.trending',
        defaultMessage: 'Trending',
    },
    recentlySearched: {
        id: 'header.recently_searched',
        defaultMessage: 'Recently searched',
    },
})
